export const APP_CONSTS = {
  APP_POSTMARK_TOKEN: process.env.APP_POSTMARK_TOKEN,
  APP_SENDER_EMAIL: process.env.APP_SENDER_EMAIL,
};
